
import { Badge } from "@/components/ui/badge";
import { CategoryFormData } from "./CategoryForm";

interface CategoryPreviewProps {
  formData: CategoryFormData;
}

export function CategoryPreview({ formData }: CategoryPreviewProps) {
  return (
    <div className="flex gap-2">
      <span className="text-sm text-gray-600">Pré-visualização:</span>
      <Badge 
        style={{ 
          backgroundColor: formData.color_hex,
          borderColor: formData.border_color_hex,
          color: formData.text_color_hex
        }}
        className="border"
      >
        {formData.name || "Nome da categoria"}
      </Badge>
    </div>
  );
}
